export const defaultSelectedRadius = {
  "name": null,
  "referencedServices": [],
  "primary": {
    "accountingType": "disable",
    "authenticateServer": null,
    "authenticationType": "PAP",
    "port": null,
    "secret": null,
    "accounting": {
      "accountingServer": null,
      "authenticationType": "PAP",
      "port": null,
      "secret": null
    }
  },
  "secondary": {
    "accountingType": "disable",
    "authenticateServer": null,
    "authenticationType": "PAP",
    "port": null,
    "secret": null,
    "accounting": {
      "accountingServer": null,
      "authenticationType": "PAP",
      "port": null,
      "secret": null
    }
  }
}

export const defaultAuthTypeDefinition = {
  "PAP": { label: "PAP", value: "PAP" },
  "MSCHAPV2": { label: "MS-CHAPv2", value: "MSCHAPV2" },
};

export const defaultAuthTypes = [
  { ...defaultAuthTypeDefinition.PAP, isSelected: true },
  { ...defaultAuthTypeDefinition.MSCHAPV2, isSelected: false },
];

export const defaultAuthTypeList = {
  primary: defaultAuthTypes,
  primaryAccounting: defaultAuthTypes,
  secondary: defaultAuthTypes,
  secondaryAccounting: defaultAuthTypes,
}

export const defaultAccountingDefinition = {
  "disable": { label: "Disable", value: "disable" },
  "independent": { label: "Independent", value: "independent" },
  "asAuthenticateServer": { label: "As Authenticate Server", value: "asAuthenticateServer" },
}

export const defaultAccountings = [
  { ...defaultAccountingDefinition.disable, isSelected: true },
  { ...defaultAccountingDefinition.independent, isSelected: false },
  { ...defaultAccountingDefinition.asAuthenticateServer, isSelected: false },
];

export const defaultAccountingList = {
  primary: defaultAccountings,
  primaryAccounting: defaultAccountings,
  secondary: defaultAccountings,
  secondaryAccounting: defaultAccountings,
}

export const defaultIsCollapse = {
  primary: true,
  primaryAccounting: true,
  secondary: true,
  secondaryAccounting: true,
}

export const defaultIsShowPassword = {
  primary: false,
  primaryAccounting: false,
  secondary: false,
  secondaryAccounting: false,
}